import { t } from "../../i18n";
import { CopyButton } from "../CopyButton";

export function PathLabel({ path }: { path: string }) {
  return (
    <div className="mt-2 flex min-w-0 items-center gap-2 rounded-lg bg-stone-100/80 px-2.5 py-2 dark:bg-white/5">
      <code className="min-w-0 flex-1 truncate text-xs text-stone-700 dark:text-stone-200">
        {path}
      </code>
      <CopyButton value={path} label={t("Copy path")} />
    </div>
  );
}
